// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link,
  useLocation,
  NavLink,
} from "react-router-dom";
import Home from "./components/Home";
import About from "./components/About";
import Tours from "./components/Tours";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Login from "./components/Login";
import Register from "./components/Register";
import ShoppingCart from "./components/shopping-cart";
import CityWalk from "./components/CityWalk";
import HistoricalCultural from "./components/HistoricalCultural";
import Excursions from "./components/Excursions";
import SlumTours from "./components/SlumTours";
import ReviewPage from "./components/ReviewPage";
import TermsOfService from "./components/TermsOfService";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword  from "./components/ResetPassword";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./index.css";

function App() {
  return (
    <Router>
      <div id="root">
        <Navbar />
        <MainContent />
        <Footer />
      </div>
    </Router>
  );
}

function MainContent() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  return (
    <div className={isHome ? "" : "container mt-5 pt-5"}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/shopping-cart" element={<ShoppingCart />} />
        <Route path="/city-walk" element={<CityWalk />} />
        <Route path="/historical-cultural" element={<HistoricalCultural />} />
        <Route path="/excursions" element={<Excursions />} />
        <Route path="/slum-tours" element={<SlumTours />} />
        <Route path="/review/:bookingId" element={<ReviewPage />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy"   element={<PrivacyPolicy />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
      </Routes>
    </div>
  );
}

function Navbar() {
  const location = useLocation();

  React.useEffect(() => {
    const navbarCollapse = document.querySelector(".navbar-collapse");
    if (navbarCollapse && navbarCollapse.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }
  }, [location]);

  const handleNavClick = () => {
    const navbarCollapse = document.querySelector(".navbar-collapse");
    if (navbarCollapse && navbarCollapse.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Jost:wght@400;600&display=swap');

        .navbar-main {
          background: linear-gradient(to bottom, rgba(0,0,0,0.75) 0%, transparent 100%) !important;
          backdrop-filter: blur(0px);
          transition: background 0.4s;
          padding-top: 0.75rem;
          padding-bottom: 0.75rem;
        }
        .navbar-main.scrolled {
          background: rgba(10,10,10,0.95) !important;
          backdrop-filter: blur(12px);
          box-shadow: 0 1px 0 rgba(201,168,76,0.2);
        }

        /* ── CIRCULAR LOGO ── */
        .logo-circle {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          border: 2px solid rgba(201,168,76,0.7);
          overflow: hidden;
          background: rgba(0,0,0,0.4);
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 0 0 3px rgba(201,168,76,0.15);
          transition: border-color 0.3s, box-shadow 0.3s;
        }
        .logo-circle:hover {
          border-color: rgba(201,168,76,1);
          box-shadow: 0 0 0 4px rgba(201,168,76,0.25);
        }
        .logo-circle img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .brand-text {
          font-family: 'Jost', sans-serif;
          font-weight: 600;
          font-size: 1rem;
          letter-spacing: 0.5px;
          text-shadow: 1px 1px 4px rgba(0,0,0,0.9);
          color: #fff !important;
          line-height: 1.2;
        }
        .brand-text small {
          display: block;
          font-size: 0.62rem;
          font-weight: 400;
          letter-spacing: 2.5px;
          text-transform: uppercase;
          color: rgba(201,168,76,0.85);
        }

        .nav-link-custom {
          font-family: 'Jost', sans-serif !important;
          font-size: 0.78rem !important;
          font-weight: 500 !important;
          letter-spacing: 1px !important;
          text-transform: uppercase !important;
          color: rgba(255,255,255,0.85) !important;
          padding: 0.4rem 0.75rem !important;
          border-radius: 3px;
          transition: color 0.2s, background 0.2s !important;
          position: relative;
        }
        .nav-link-custom::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 1px;
          background: #C9A84C;
          transition: width 0.3s;
        }
        .nav-link-custom:hover { color: #E8C97A !important; }
        .nav-link-custom:hover::after { width: 60%; }
        .nav-link-custom.active-link { color: #C9A84C !important; }
        .nav-link-custom.active-link::after { width: 60%; }

        /* Mobile menu */
        @media (max-width: 991px) {
          .mobile-nav {
            background: rgba(10,10,10,0.97) !important;
            backdrop-filter: blur(16px);
            border-top: 1px solid rgba(201,168,76,0.2);
            padding: 1rem 1.5rem;
            border-radius: 0 0 8px 8px;
          }
          .nav-link-custom { padding: 0.7rem 0 !important; }
          .nav-link-custom::after { display: none; }
        }
      `}</style>

      <nav
        className="navbar navbar-expand-lg fixed-top navbar-main"
        id="mainNav"
      >
        {/* Scroll effect */}
        <NavbarScrollEffect />

        <div className="container-fluid px-3 px-lg-4">

          {/* Brand */}
          <Link className="navbar-brand d-flex align-items-center gap-2" to="/">
            <div className="logo-circle">
              <img src="/logo.png" alt="Nairobi's Ultimate Experience Logo" />
            </div>
            <span className="brand-text">
              Nairobi's Ultimate
              <small>City Tours &amp; Adventures</small>
            </span>
          </Link>

          {/* Hamburger */}
          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
            style={{ color: "rgba(255,255,255,0.8)" }}
          >
            <span className="navbar-toggler-icon" />
          </button>

          {/* Links */}
          <div className="collapse navbar-collapse mobile-nav" id="navbarNav">
            <ul className="navbar-nav ms-auto align-items-lg-center">
              {[
                { to: "/", label: "Home" },
                { to: "/city-walk", label: "Downtown Walk" },
                { to: "/historical-cultural", label: "Historical & Cultural" },
                { to: "/excursions", label: "Excursions" },
                { to: "/slum-tours", label: "Slum Tours" },
                { to: "/about", label: "About" },
                { to: "/contact", label: "Contact" },
              ].map(({ to, label }) => (
                <li key={to} className="nav-item">
                  <NavLink
                    to={to}
                    end={to === "/"}
                    onClick={handleNavClick}
                    className={({ isActive }) =>
                      `nav-link nav-link-custom${isActive ? " active-link" : ""}`
                    }
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </nav>
    </>
  );
}

/* Adds .scrolled class to navbar on scroll */
function NavbarScrollEffect() {
  React.useEffect(() => {
    const nav = document.getElementById("mainNav");
    const onScroll = () => {
      if (window.scrollY > 60) nav?.classList.add("scrolled");
      else nav?.classList.remove("scrolled");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return null;
}

export default App;
